'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */


exports.default = pathDiff;

var _ramda = require('ramda');

var _modula = require('modula');

var _immutable = require('modula/dist/immutable');

var isPrimitiveType = (0, _ramda.anyPass)([(0, _ramda.is)(Number), (0, _ramda.is)(Boolean), (0, _ramda.is)(String), _ramda.isNil]);

var bothTrue = function bothTrue(testType) {
  return function (value, newValue) {
    return testType(value) && testType(newValue);
  };
};

var bothPrimitiveTypes = bothTrue(isPrimitiveType);
var oneSideNil = function oneSideNil(value, newValue) {
  return (0, _ramda.isNil)(value) && !(0, _ramda.isNil)(newValue) || !(0, _ramda.isNil)(value) && (0, _ramda.isNil)(newValue);
};
var bothModels = bothTrue(_modula.isModel);
var bothImmutables = bothTrue(_immutable.isImmutableType);
var bothArrays = bothTrue((0, _ramda.is)(Array));

function pathDiffForModel(contextPath, oldModel, newModel) {
  var oldProps = oldModel.props();
  var newProps = newModel.props();

  return pathDiffForObject(contextPath, oldProps, newProps);
}

function pathDiffForImmutable(contextPath, oldIterable, newIterable) {
  var updatedPaths = [];
  var deletedPaths = [];
  var createdPaths = [];

  oldIterable.forEach(function (value, key) {
    if (newIterable.has(key)) {
      var newValue = newIterable.get(key);

      if (value !== newValue) {
        var _pathDiff = pathDiff((0, _ramda.append)(key, contextPath), value, newValue),
            childUpdatedPaths = _pathDiff.updatedPaths,
            childDeletedPaths = _pathDiff.deletedPaths,
            childCreatedPaths = _pathDiff.createdPaths;

        updatedPaths = (0, _ramda.concat)(updatedPaths, childUpdatedPaths);
        deletedPaths = (0, _ramda.concat)(deletedPaths, childDeletedPaths);
        createdPaths = (0, _ramda.concat)(createdPaths, childCreatedPaths);
      }
    } else {
      deletedPaths.push((0, _ramda.append)(key, contextPath));
    }
  });

  newIterable.forEach(function (value, key) {
    if (!oldIterable.has(key)) {
      createdPaths.push((0, _ramda.append)(key, contextPath));
    }
  });

  return { updatedPaths: updatedPaths, deletedPaths: deletedPaths, createdPaths: createdPaths };
}

function pathDiffForArray(contextPath, oldArray, newArray) {
  var updatedPaths = [];
  var deletedPaths = [];
  var createdPaths = [];

  (0, _ramda.addIndex)(_ramda.forEach)(function (value, idx) {
    if (newArray[idx] !== undefined) {
      var newValue = newArray[idx];

      if (value !== newValue) {
        var _pathDiff2 = pathDiff((0, _ramda.append)(idx, contextPath), value, newValue),
            childUpdatedPaths = _pathDiff2.updatedPaths,
            childDeletedPaths = _pathDiff2.deletedPaths,
            childCreatedPaths = _pathDiff2.createdPaths;

        updatedPaths = (0, _ramda.concat)(updatedPaths, childUpdatedPaths);
        deletedPaths = (0, _ramda.concat)(deletedPaths, childDeletedPaths);
        createdPaths = (0, _ramda.concat)(createdPaths, childCreatedPaths);
      }
    } else {
      deletedPaths.push((0, _ramda.append)(idx, contextPath));
    }
  }, oldArray);

  (0, _ramda.addIndex)(_ramda.forEach)(function (value, idx) {
    if (oldArray[idx] === undefined) {
      createdPaths.push((0, _ramda.append)(idx, contextPath));
    }
  }, newArray);

  return { updatedPaths: updatedPaths, deletedPaths: deletedPaths, createdPaths: createdPaths };
}

function pathDiffForObject(contextPath, oldObject, newObject) {
  var updatedPaths = [];
  var deletedPaths = [];
  var createdPaths = [];

  (0, _ramda.forEach)(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if ((0, _ramda.has)(key, newObject)) {
      var newValue = newObject[key];

      if (value !== newValue) {
        var _pathDiff3 = pathDiff((0, _ramda.append)(key, contextPath), value, newValue),
            childUpdatedPaths = _pathDiff3.updatedPaths,
            childDeletedPaths = _pathDiff3.deletedPaths,
            childCreatedPaths = _pathDiff3.createdPaths;

        updatedPaths = (0, _ramda.concat)(updatedPaths, childUpdatedPaths);
        deletedPaths = (0, _ramda.concat)(deletedPaths, childDeletedPaths);
        createdPaths = (0, _ramda.concat)(createdPaths, childCreatedPaths);
      }
    } else {
      deletedPaths.push((0, _ramda.append)(key, contextPath));
    }
  }, (0, _ramda.toPairs)(oldObject));

  (0, _ramda.forEach)(function (key) {
    if (!(0, _ramda.has)(key, oldObject)) {
      createdPaths.push((0, _ramda.append)(key, contextPath));
    }
  }, (0, _ramda.keys)(newObject));

  return { updatedPaths: updatedPaths, deletedPaths: deletedPaths, createdPaths: createdPaths };
}

// paths will be returned in depth first manner
function pathDiff(contextPath, oldThing, newThing) {
  if (bothPrimitiveTypes(oldThing, newThing) && oldThing !== newThing || oneSideNil(oldThing, newThing)) {
    return {
      updatedPaths: [contextPath],
      deletedPaths: [],
      createdPaths: []
    };
  } else if (bothModels(oldThing, newThing)) {
    return pathDiffForModel(contextPath, oldThing, newThing);
  } else if (bothImmutables(oldThing, newThing)) {
    return pathDiffForImmutable(contextPath, oldThing, newThing);
  } else if (bothArrays(oldThing, newThing)) {
    return pathDiffForArray(contextPath, oldThing, newThing);
  } else {
    return pathDiffForObject(contextPath, oldThing, newThing);
  }
}